import { useApiMutation, useApiQuery } from '@/shared/hooks';
import type {
  CompanyTenant,
  CompanyTenantCreateRequest,
  CompanyTenantsResponse,
  UserCompany,
} from './types';

// GET /users/me/companies — returns the list of companies the caller can access.
// For client roles → one entry (home company, is_default=true).
// For pentester → only assigned companies.
// For root / privileged_pentester → all companies.
export const useMyCompaniesQuery = () => {
  return useApiQuery<UserCompany[]>(['user', 'me', 'companies'], '/users/me/companies', {
    staleTime: 60_000,
    retry: false,
  });
};

export const useCompanyTenantsQuery = (companyId?: string, enabled = true) => {
  return useApiQuery<CompanyTenantsResponse>(
    ['company', companyId ?? 'active', 'tenants'],
    '/companies/__COMPANY__/tenants',
    {
      enabled: enabled && Boolean(companyId),
      staleTime: 30_000,
      retry: false,
    }
  );
};

export const useCreateCompanyTenantMutation = () => {
  return useApiMutation<CompanyTenant, CompanyTenantCreateRequest>(
    '/companies/__COMPANY__/tenants',
    'POST',
    {
      invalidateQueries: [['company'], ['user', 'me', 'companies']],
    }
  );
};
